<template>
  <div id="app">
    <h1> TinyPNG 使用 </h1>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <div style="display: flex; justify-content: center; align-items: center; margin-top: 50px;">
            <div style="width: 100%; max-width: 800px; position: relative">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基础使用" name="base">
                  <Base />
                </el-tab-pane>
                <el-tab-pane label="WebWork" name="webwork">
                  <WebWork />
                </el-tab-pane>
                <el-tab-pane label="jpeg/jpg" name="jpeg">
                  <Jpeg />
                </el-tab-pane>
                <el-tab-pane label="CompressWorker" name="compressWorker">
                  <CompressWorker />
                </el-tab-pane>
                <el-tab-pane label="GitHub" name="github">
                  <el-link size="mini" type="primary" href="https://github.com/viteui/tinypng-lib"
                  target="_blank">github.com/viteui/tinypng-lib</el-link>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Base from './components/Base.vue';
import WebWork from './components/WebWork.vue';
import Jpeg from './components/Jpeg.vue';
import CompressWorker from './components/CompressWorker.vue';



export default {
  name: 'App',
  components: {
    Base,
    WebWork,
    Jpeg,
    CompressWorker
  },
  data() {
    return {
      activeName: 'webwork'
    };
  },
  methods: {
    handleClick(tab, event) {
    }
  }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.el-upload, .el-upload-dragger {
  width: 100% !important;
}
</style>./components/CompressWorker.vue./components/Jpeg.vue